import { Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import ImageContainer from 'artkive/components/ImageContainer'
import theme from 'artkive/utils/theme'

import { CtaButton as KeepsakeCtaButton } from './Keepsakes.style'
import KeepsakeSection from './KeepsakeSection'

export const Section = withStyles(({ breakpoints }) => ({
  root: {
    backgroundColor: theme.colors.white.main,
  },
  titleWrap: {
    [breakpoints.up('md')]: {
      marginBottom: 32,
    },
  },
}))(KeepsakeSection)

// 330 rather than the frame's 326, so "Before it's a keepsake," fits on one line at 375.
export const Title = styled(Typography)(({ theme: { breakpoints } }) => ({
  [breakpoints.down('sm')]: {
    maxWidth: 330,
    margin: '0 auto',
  },
}))

export const Body = styled(Typography)(({ theme: { breakpoints } }) => ({
  maxWidth: 720,
  margin: '16px auto 0',
  textAlign: 'center',
  [breakpoints.down('sm')]: {
    textAlign: 'left',
  },
}))

export const Images = styled('div')({
  position: 'relative',
})

export const Photo = styled(ImageContainer)({
  borderRadius: 8,
  overflow: 'hidden',
})

export const Scribble = styled('img')(({ theme: { breakpoints } }) => ({
  position: 'absolute',
  left: 'calc(50% + 7px)',
  top: '69.5%',
  width: 170,
  transform: 'translate(-50%, -50%) rotate(-40deg)',
  pointerEvents: 'none',
  // The mobile frames use the green arrow, mirrored and turned to point down at the after photo.
  [breakpoints.down('sm')]: {
    left: 'calc(50% + 12px)',
    top: 'calc(50% + 3px)',
    width: 179,
    transform: 'translate(-50%, -50%) rotate(-139.88deg) scaleX(-1)',
  },
}))

export const CtaRow = styled('div')(({ theme: { breakpoints } }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: 32,
  [breakpoints.down('sm')]: {
    marginTop: 48,
  },
}))

export const CtaButton = styled(KeepsakeCtaButton)({
  fontWeight: 600,
  paddingTop: 11,
  paddingBottom: 11,
})
